import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import DataDisplay from 'app/shared/componentsRestyled/coreDesignSystem/DataDisplay';
import PropTypes from 'prop-types';

import { getExtensionItemStyles } from './LockInfo.styles';

const ExtensionItem = ({ onSelect, extensionItem, isActive }) => {
  const onClick = useCallback(() => {
    onSelect(extensionItem);
  }, [extensionItem, onSelect]);

  return (
    <Box sx={getExtensionItemStyles(isActive)} onClick={onClick}>
      <DataDisplay title="Extension Term" value={extensionItem.term} />
      <DataDisplay title="Extension Price" value={extensionItem.price} />
    </Box>
  );
};

ExtensionItem.propTypes = {
  extensionItem: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default memo(ExtensionItem);
